import { UseFormReturn } from "react-hook-form"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import { CatalogFormData, parseTimeline, timelineToString } from "../catalog-form-schema"

interface RequirementsProps {
  form: UseFormReturn<CatalogFormData>
}

export function Requirements({ form }: RequirementsProps) {
  const { register, setValue } = form

  const handleTimelineChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const timelineSteps = parseTimeline(e.target.value)
    setValue('timeline', timelineSteps)
  }

  const timelineValue = form.watch('timeline')
  const timelineString = timelineToString(timelineValue)

  return (
    <div className="space-y-6">
      <div>
        <Label htmlFor="prerequisites">Prerequisites</Label>
        <Textarea
          placeholder="Enter prerequisites, one per line"
          rows={4}
          className="font-mono"
          {...register("prerequisites")}
        />
      </div>

      <div>
        <Label htmlFor="timeline">Itinerary</Label>
        <p className="text-sm text-muted-foreground mb-2">
          Enter each step of the event timeline, one per line
        </p>
        <Textarea
          placeholder="Registration and check-in&#10;Opening remarks&#10;Activity session&#10;Closing and feedback"
          rows={6}
          className="font-mono"
          value={timelineString}
          onChange={handleTimelineChange}
        />
      </div>
    </div>
  )
}